import {
    SET_PROPOSAL_LIST,
    SET_PROPOSAL_LIST_FILTER_DATA,
    SET_PROPOSAL_LIST_META,
    PROPOSAL_INIT_STATE,
    SET_PROPOSAL_LIST_BY_DATE,
    SET_PROPOSAL_LIST_BY_HOUR,
} from "./types";

export const proposalReducer = (state = PROPOSAL_INIT_STATE, action) => {
    switch (action.type) {
        case SET_PROPOSAL_LIST:
            return {...state, proposalList: action.payload};
        case SET_PROPOSAL_LIST_META:
            return {...state, proposalListMeta: action.payload};
        case SET_PROPOSAL_LIST_BY_DATE:
            return {...state, proposalListByDate: action.payload};
        case SET_PROPOSAL_LIST_FILTER_DATA:
            return {...state, proposalListFilterData: action.payload};
        case SET_PROPOSAL_LIST_BY_HOUR:
            return {...state, proposalListByHour: action.payload};
        default:
            return state
    }
}